import {Pipe, PipeTransform} from '@angular/core';
import {TypeUtils} from "../utils/type-utils";

@Pipe({
    name: 'timeFromNow',
    standalone: false
})
export class TimeFromNowPipe implements PipeTransform {

  constructor() {}

  private calcDateByOffset(date: Date): Date {
    const localTimezoneOffset: number = (new Date()).getTimezoneOffset() * 60 * 1000;
    return new Date(date.getTime() + localTimezoneOffset);
  };

  transform(fromDate: Date): string {
    if (!fromDate) {
      return '-';
    }

    const oneDay: number = 24 * 60 * 60 * 1000;
    const lessThan5Mins: boolean = new Date().getTime() - new Date(fromDate).getTime() < 5 * 60 * 1000;
    let timeFromNow: any = Math.floor((new Date().getTime() - new Date(fromDate).getTime()) / oneDay);
    if (TypeUtils.isNumber(timeFromNow)) {
      if (lessThan5Mins) {
        timeFromNow = 'Just now';
      }
      else if (timeFromNow < 1) {
        const hour: number = 24;
        timeFromNow = Math.floor(timeFromNow / hour);
        if (timeFromNow <= 1) {
          timeFromNow = '1 hour ago';
        }
        else {
          timeFromNow = timeFromNow + ' hours ago';
        }
      }
      else if (timeFromNow === 1) {
        timeFromNow = 'today';
      }
      else if (timeFromNow < 7) {
        timeFromNow = timeFromNow + ' days ago';
      }
      else if (timeFromNow <= 28) {
        timeFromNow = Math.round(timeFromNow / 7) === 1 ? Math.round(timeFromNow / 7) + ' week ago' : Math.round(timeFromNow / 7) + ' weeks ago';
      }
      else if (timeFromNow < 365) {
        timeFromNow = Math.round(timeFromNow / 30) === 1 ? Math.round(timeFromNow / 30) + ' month ago' : Math.round(timeFromNow / 30) + ' months ago';
      }
      else {
        timeFromNow = Math.round(timeFromNow / 365) === 1 ? +Math.round(timeFromNow / 365) + ' year ago' : Math.round(timeFromNow / 365) + ' years ago';
      }
    }

    return timeFromNow;
  }

}
